// src/components/FaqFooter.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../styles/Footer.css";
import {useTranslation} from "react-i18next";
import {getPath, isValidEmail} from "../utils/functions";

function Footer() {
  const [t, i18n] = useTranslation();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!isValidEmail(email)) {
      setErrorMessage(t('footer.invalid_email'));
      setTimeout(() => setErrorMessage(""), 10000);
      return;
    }

    try {
      const response = await fetch('https://backend.activikid.hk/api/emails', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "data": {
            "email": email
          }
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || t('footer.subscription_failed'));
      }

      setSubscribed(true);
      setErrorMessage("");
      setEmail("");

      setTimeout(() => setSubscribed(false), 10000);

    } catch (error) {
      console.error('Subscription error:', error);
      setErrorMessage(error.message || t('footer.subscription_error'));
      setTimeout(() => setErrorMessage(""), 10000);
    }
  };

  return (
      <footer className="footer-part">
        {/* Top row: Subscribe & Social */}
        <div className="footer-top container">
          <div className="row">
            {/* Subscribe Column */}
            <div className="col-md-6 footer-left">
              <h5 className="footer-heading">{t('footer.title1')}</h5>
              <div className="footer-subscribe">
                <input
                    type="email"
                    placeholder={t('footer.email_placeholder')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button disabled={subscribed} onClick={handleSubscribe}>
                  {subscribed ? <img src="/Images/footer-check.png" className="footer-check"/> : t('footer.subscribe')}
                </button>
              </div>
              {errorMessage && (
                  <p style={{ color: "red", fontSize: "1rem", marginTop: "0.5rem" }}>
                    {errorMessage}
                  </p>
              )}
            </div>
            {/* Social Column */}
            <div className="col-md-6 footer-right">
              <h5 className="footer-heading">{t('footer.title2')}</h5>
              <div className="footer-social-icons">
                <a href="https://www.instagram.com/activikidhk/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-instagram" />
                </a>
                <a href="https://api.whatsapp.com/send/?phone=57404060&text=Hello%20ActiviKid%EF%BC%81%E6%88%91%E6%83%B3%E4%BA%86%E8%A7%A3%E6%9B%B4%E5%A4%9A%EF%BC%81&type=phone_number&app_absent=0" aria-label="Whatsapp" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" />
                </a>
                <a href="mailto:cs@activikid.hk" aria-label="email" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-envelope" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom row: Legal links & Copyright */}
        <div className="footer-bottom container text-center">
          <div className="row justify-content-start">
            <div className="col-auto">
              <ul className="footer-links list-inline mb-0">
                <li className="list-inline-item">
                  <a href={getPath('/discover-more')}>{t('footer.link1')}</a>
                  <mark className="footer-delimiter">{"|"}</mark>
                </li>
                <li className="list-inline-item">
                  <Link to="#">{t('footer.link2')}</Link>
                  <mark className="footer-delimiter">{"|"}</mark>
                </li>
                <li className="list-inline-item">
                  <a href={getPath('/terms-and-conditions')}>{t('footer.link3')}</a>
                  <mark className="footer-delimiter">{"|"}</mark>
                </li>
                <li className="list-inline-item">
                  <a href={getPath('/privacy')}>{t('footer.link4')}</a>
                  <mark className="footer-delimiter">{"|"}</mark>
                </li>
                <li className="list-inline-item">
                  <a href={getPath('/contact')}>{t('footer.contact_us')}</a>
                  <mark className="footer-delimiter">{"|"}</mark>
                </li>
                <li className="list-inline-item">
                  <Link to="#">{t('footer.link5')}</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="row justify-content-start mt-10">
            <div className="col-auto">
              <p className="mb-0 text-white text-md-start">
                {t('footer.copyright')}
              </p>
            </div>
          </div>
        </div>
      </footer>
  );
}

export default Footer;
